export const MULTICHAIN_TOKEN_PREFIX = 'multi';
